import { Component, OnDestroy, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LLMActionsInjectorService } from '../../services/llm-actions-injector.service';
import { Subject } from 'rxjs';

@Component({
    selector: 'masthead-secondary, app-masthead-secondary',
    templateUrl: './masthead-secondary.component.html',
    styleUrls: ['./masthead-secondary.component.scss'],
    standalone: false
})
export class MastheadSecondaryComponent implements AfterViewInit, OnDestroy {
  private destroy$ = new Subject<void>();

  constructor(
    private llmInjectorService: LLMActionsInjectorService,
    private route: ActivatedRoute
  ) {}


  ngAfterViewInit(): void {
    this.llmInjectorService.setupAutoInjection('.-action-section', this.destroy$, this.route);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
